import React from "react";
import MyModal from "../Common/MyModal";
import { Button, Modal } from "react-bootstrap";
import SupportIcon from "../../assets/icons/Icon_Library/application icons/general/contact_support.svg2";
import MyIcon from "../Common/MyIcon";

export default function AccessSupportModal() {
  return (
    <MyModal
      label={
        <div className="d-flex align-items-center">
          <MyIcon Icon={SupportIcon} width={20} />
          <span className="fw-bold text-navy ms-2">Access Support</span>
        </div>
      }
      size="md"
      heading="Need Help Accessing This Solution?"
      subheading="Our support team is here to help you with any access issues you may be facing. Please reach out to us and we'll assist you in gaining access to this solution."
    >
      <Modal.Body className="p-0">
        <div className="p-3">
          <p>
            If you need help accessing this solution, please contact our support
            team at{" "}
            <a href="mailto: support@example.com">support@example.com</a>.
          </p>
          <div className="d-flex justify-content-end">
            <Button className="bg-colored-reverse fw-bold">Start Chat</Button>
          </div>
        </div>
      </Modal.Body>
    </MyModal>
  );
}
